import { cn } from "@/lib/utils";
import Lottie from "lottie-react";

import errorAnimation from "./Error.json";
import { Button } from "@/components/ui/button";
import { IconRotateClockwise } from "@tabler/icons-react";

type Props = {
  className?: string;
  onRetry?: () => void;
};

const ErrorState = ({ className, onRetry }: Props) => {
  return (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <div className="w-[42px]">
        <Lottie
          animationData={errorAnimation}
          loop={true}
          autoplay={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div className="mt-4 text-[12px] font-medium text-brand-primary-800">
        This didn’t load right
      </div>
      <div className="text-[12px] text-brand-primary-600">
        Looks like our code took a coffee break, Try again in a sec.
      </div>
      <div className="mt-4">
        <Button
          variant="sq-outline"
          size="sm"
          className=""
          onClick={onRetry ? onRetry : () => window.location.reload()}
        >
          <IconRotateClockwise size={14} className="text-brand-primary-600" />
          <span>Try again</span>
        </Button>
      </div>
    </div>
  );
};

export default ErrorState;
